/* src/app/json-editor-module/json-forms-new-popup/json-forms-node-new/json-forms-node-new.component.scss */
.example-form {
  margin: 10px;
}
.title {
  font-weight: 400;
  font-size: 100%;
  margin-top: 14px;
}
.main {
  overflow: auto;
  height: calc(100% - 80px);
}
.titleArray {
  font-weight: 400;
  font-size: 16px;
  padding-left: 10px;
}
.link {
  text-decoration: underline;
  font-weight: 700;
  color: #3b80f9;
  cursor: pointer;
  font-size: 12px;
}
.buttons {
  width: 100%;
  padding: 15px;
}
.full-width {
  width: 100%;
}
.bodyArray {
  padding-top: 7.5px;
  border-radius: 2px;
  padding-left: 15px;
  padding-right: 15px;
  margin-bottom: 15px;
}
.arrayBottom {
  border-top: 0px;
  padding-top: 3.25px;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}
.arrayTitle {
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}
form {
  gap: 10px;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.checkbox-json-editor {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
/*# sourceMappingURL=json-forms-node-new.component.css.map */
